import React, { useState } from 'react';
import * as Styles from './ConnectedAccount.styles';
import { IconClose, SocialMediaIcons } from 'gatorcomponents';

const ConnectedAccountCard = ({
  account,
  handleAccountSelect,
  handleRemoveAccount,
}) => {
  const [onHover, setOnHover] = useState(false);

  const handleClickRemoveAccount = () => {
    handleRemoveAccount && handleRemoveAccount();
  };

  return (
    <Styles.ConnectedAccountCard
      key={account.id}
      onMouseEnter={() => setOnHover(true)}
      onMouseLeave={() => setOnHover(false)}
    >
      <Styles.Clickable
        onClick={() => handleAccountSelect(account)}
        type="button"
      >
        <Styles.AccountIconWrapper>
          <SocialMediaIcons icon={account.type} brandColors size="md" />
        </Styles.AccountIconWrapper>
        <Styles.ConnectedAccountInfo>
          <Styles.ConnectedAccountName>{account.name}</Styles.ConnectedAccountName>
          <Styles.ConnectedAccountDescription>
            {account.description}
          </Styles.ConnectedAccountDescription>
        </Styles.ConnectedAccountInfo>
      </Styles.Clickable>

      {onHover && (
        <Styles.IconButton onClick={handleClickRemoveAccount}>
          <IconClose color="lowDark" />
        </Styles.IconButton>
      )}
    </Styles.ConnectedAccountCard>
  );
};

export default ConnectedAccountCard;
